// removed by extract-text-webpack-plugin
module.exports = {"root":"DropdownMenu--root--1D","isOpen":"DropdownMenu--isOpen--Nn","inline":"DropdownMenu--inline--3C","content":"DropdownMenu--content--3E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownMenu/styles.styl
// module id = 810
// module chunks = 0